export const createInstance = () => {
  const ADOBE_PDF_VIEWER_URL =
    'https://acrobatservices.adobe.com/view-sdk/viewer.js'

  ;(function () {
    var w = window
    var adc = w.AdobeDC

    if (typeof adc === 'object' && adc.View) {
      // Adobe PDF Viewer is already loaded
      return
    } else {
      var d = document
      var l = function () {
        var s = d.createElement('script')
        s.type = 'text/javascript'
        s.async = true
        s.src = ADOBE_PDF_VIEWER_URL
        var x = d.getElementsByTagName('script')[0]
        x.parentNode.insertBefore(s, x)
      }

      if (d.readyState === 'complete') {
        l()
      } else if (w.attachEvent) {
        w.attachEvent('onload', l)
      } else {
        w.addEventListener('load', l, false)
      }
    }
  })()
}
